import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarInsetProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSidebarContext
} from "../../context";

const SidebarInset: FC<ISidebarInsetProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const provider = useSidebarContext({
        part: "Sidebar.Inset"
    });

    const customTheme = customThemeProp ?? provider?.customTheme;

    const {
        shapeConfigs,
        shadowAlpha,
        elevations,
        radiuses,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        variant: provider?.variant ?? "sidebar",
        isPhone: provider?.isPhone ?? false,
        shapeConfigs,
        shadowAlpha,
        elevations,
        radiuses,
        borders,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="main"
    >
        {children}
    </View>;
};
export default SidebarInset;
